export interface IngredientLike {
  item?: string | null;
  amount?: string | null;
  unit?: string | null;
  prepNotes?: string | null;
  sectionHeader?: string | null;
}

/**
 * Section headings are metadata and may be attached to a real ingredient.
 * Empty items are presentational. Older heading-only rows were persisted with
 * generic placeholder items, so preserve those as headings when every actual
 * ingredient field is empty.
 */
export function isRealIngredient(ingredient: IngredientLike): boolean {
  const item = ingredient.item?.trim() ?? "";
  if (!item) return false;

  const isLegacyHeadingPlaceholder =
    Boolean(ingredient.sectionHeader?.trim()) &&
    ["ingredient", "untitled", "unknown ingredient"].includes(
      item.toLowerCase(),
    ) &&
    !ingredient.amount?.trim() &&
    !ingredient.unit?.trim() &&
    !ingredient.prepNotes?.trim();

  return !isLegacyHeadingPlaceholder;
}